var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrafica02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 719.217 135.286",
    style: {
      enableBackground: "new 0 0 719.217 135.286"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grarfica_02"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "323.174,118.522 303.652,135.286 278.783,135.286 299.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "287.174,118.522 267.652,135.286 242.783,135.286 263.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "251.174,118.522 231.652,135.286 206.783,135.286 227.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "215.174,118.522 195.652,135.286 170.783,135.286 191.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "179.174,118.522 159.652,135.286 134.783,135.286 155.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "143.174,118.522 123.652,135.286 98.783,135.286 119.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "108.174,118.522 88.652,135.286 63.783,135.286 84.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "75.174,118.522 55.652,135.286 30.783,135.286 51.174,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "43.391,118.522 23.87,135.286 0,135.286 19.391,118.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "610.87,110.678 719.217,0 719.217,19.985 619.391,125.069 510.087,125.069  525.035,110.723  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070909"
    },
    points: "500.957,125.069 325.957,125.069 333.848,118.743 472.913,118.743 481.587,109.721  516.413,109.721  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrafica02);
export default __webpack_public_path__ + "static/media/Grafica02.254da5ddc3339d44ad8afd46326c2588.svg";
export { ForwardRef as ReactComponent };